import { NodeViewWrapper, NodeViewWrapperProps } from '@tiptap/react';
import { FC, useCallback, useEffect, useRef } from 'react';
import cn from 'classnames';
import { getPresetId } from '../../../components/utils/tiptap';
import { DaGalleryAttrs } from '../gallery';
import DaGallery from './DaGallery';
import { EXTENSION_TYPE_NAME } from '../constants';

import viewerStyles from '../Viewer/Viewer.scss';

const DeviationNodeView: FC<NodeViewWrapperProps> = props => {
  const Renderer = props.editor.extensionStorage['da-ext-renderers'].gallery;
  const { editor, updateAttributes, extension, node } = props;
  const { options } = extension;
  const attrs: DaGalleryAttrs = node.attrs;
  const editorDomRef = useRef<HTMLElement>(undefined);

  useEffect(() => {
    editorDomRef.current = editor.view.dom;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onResizeEnd = useCallback(
    (nextWidth: number) => {
      updateAttributes({
        width: nextWidth,
      });
    },
    [updateAttributes]
  );

  const nodeKey = `gallery-${!attrs.width ? 'default' : 'custom'}`;

  return (
    <NodeViewWrapper
      key={nodeKey}
      data-drag-handle="true"
      className={cn(
        'draggable-atomic',
        viewerStyles['gallery-container'],
        viewerStyles[attrs.alignment],
        options.smallMedia && viewerStyles['small-media'],
        viewerStyles[`preset-${getPresetId(editor)}`]
      )}
      data-da-type={EXTENSION_TYPE_NAME}
    >
      <DaGallery
        Renderer={Renderer}
        onResizeEnd={onResizeEnd}
        extOptions={options}
        defaultWidth={options.defaultWidth}
        editorDomRef={editorDomRef}
        deviations={attrs.deviations}
        linkOverrides={attrs.linkOverrides}
        attrWidth={attrs.width}
        gridItemHeight={attrs.gridItemHeight}
        gridItemWidth={attrs.gridItemWidth}
        itemCropping={attrs.itemCropping}
        layout={attrs.layout}
        layoutRowAlignment={attrs.layoutRowAlignment}
        layoutSpacing={attrs.layoutSpacing}
        torpedoRowHeight={attrs.torpedoRowHeight}
        alignment={attrs.alignment}
      />
    </NodeViewWrapper>
  );
};
DeviationNodeView.displayName = 'DeviationNodeView';

export default DeviationNodeView;
